"use client";
import { useState, useEffect, useContext, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  IconButton,
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Autocomplete,
  TextField,
  alpha,
  Tooltip,
  InputAdornment,
  Collapse,
  Drawer,
  Divider,
  Badge,
  Chip,
  useMediaQuery,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Alert,
  Stack,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { ErpContext } from "../../context/ErpContext.js";
import "./TablaVentasComponent.css";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import CategoryIcon from "@mui/icons-material/Category";
import BadgeIcon from "@mui/icons-material/Badge";
import SearchIcon from "@mui/icons-material/Search";
import ReplayIcon from "@mui/icons-material/Replay";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import TuneIcon from "@mui/icons-material/Tune";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import CloseIcon from "@mui/icons-material/Close";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import PersonIcon from "@mui/icons-material/Person";
import PaymentIcon from "@mui/icons-material/Payment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Checkbox from "@mui/material/Checkbox";
import CalculateIcon from "@mui/icons-material/Calculate";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import InfoIcon from "@mui/icons-material/Info";
import EditIcon from "@mui/icons-material/Edit";

import dayjs from "dayjs";

import "./TablaTransaccionComponent.css";

import ModalViewTablaVenta from "./ModalViewTablaVenta.js";
import ModalViewTablaCompra from "./ModalViewTablaCompra.js";
import ModalViewTablaPresupuesto from "./ModalViewTablaPresupuesto.js";
import ModalViewTablaIngreso from "./ModalViewTablaIngreso.js";
import ModalViewTablaEgreso from "./ModalViewTablaEgreso.js";
import ModalViewTablaDevolucion from "./ModalViewTablaDevolucion.js";
import ModalViewTablaGenerico from "./ModalViewTablaGenerico.js";

import Swal from "sweetalert2";

import CustomPagination from "./CustomPagination"; // Tu componente de paginación

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

export default function TablaVentas() {
  const {
    getTipoTransaccion,
    tipoTransaccion,
    getEntidad,
    entidades,
    getMedioDePago,
    medioDePago,
    getTransaccionItem,
    getTransaccionItemID,
    generarFacturaPDF,
    itemUbicacion,
    getTransaccionTransformed,
    fetchFilteredTransactions,
    tipoMedioDePago,
    medioDePagoIdTipoEspecifico,
    getTipoMedioDePago,
    getMedioDePagoIdTipoEspecifico,
    getEntidadByID,
    getItemById,
    getItemUbicacionFilter,
    getUbicacion,
    ubicaciones,
    generarRemitoPDF,
    updateDeleteTransaccion,
    entidadesClientesTresLetras,
    getEntidadesClientesTresLetras,
    isNavbarCollapsed,
    getFechaHoraActualClient,
    entidadAtributoNoEliminados,
    getEntidadAtributoNoEliminados,
    getEntidadAtributoClasificacionByIdAtributo,
    postTransaccionAuditoria,
    user,
    tieneAccesoFuncionalidad,
    getAndPostCajaDatos,
    getCuentaCorrienteByIdEntidad,
    getTransaccionItemIDEnCompras,
  } = useContext(ErpContext);

  const [formattedTransacciones, setFormattedTransacciones] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [openModalVenta, setOpenModalVenta] = useState(false);
  const [openModalCompra, setOpenModalCompra] = useState(false);
  const [openModalPresupuesto, setOpenModalPresupuesto] = useState(false);
  const [openModalIngreso, setOpenModalIngreso] = useState(false);
  const [openModalEgreso, setOpenModalEgreso] = useState(false);
  const [openModalDevolucion, setOpenModalDevolucion] = useState(false);
  const [openModalGenerico, setOpenModalGenerico] = useState(false);
  const [transaccionItems, setTransaccionItems] = useState([]);
  const [compraItems, setCompraItems] = useState([]);
  const [selectedTransaccionId, setSelectedTransaccionId] = useState(null);
  const [selectedTransaccion, setSelectedTransaccion] = useState(null);
  const [selectedTransaccionEntidad, setSelectedTransaccionEntidad] =
    useState(null);

  const [selectedTipoMedioDePago, setSelectedTipoMedioDePago] = useState(null);
  const [selectedMedioDePago, setSelectedMedioDePago] = useState(null);
  const [selectedTipoTransaccion, setSelectedTipoTransaccion] = useState(null);
  const [selectedUbicacion, setSelectedUbicacion] = useState(null);

  const [transaccionTransformedReforged, setTransaccionTransformedReforged] =
    useState([]);
  const [totalesPorTipoMedioDePago, setTotalesPorTipoMedioDePago] =
    useState(null);
  const [totalesPorTipo, setTotalesPorTipo] = useState(null);

  const [totalPages, setTotalPages] = useState(0);
  const [totalCount, setTotalCount] = useState(0);

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(100); // Cantidad de filas por página

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [idTransaccionSearch, setIdTransaccionSearch] = useState(null);
  const [dniCliente, setDniCliente] = useState("");
  const [searchTextCliente, setSearchTextCliente] = useState("");

  const [filtersActive, setFiltersActive] = useState(false);

  const isFirstRender = useRef(true);

  // ===== Responsive flags =====
  const isLaptopDown = useMediaQuery("(max-width:1200px)");
  const isMobile = useMediaQuery("(max-width:600px)");

  // Estados para el menú lateral (solo desktop)
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [mostrarFiltroMontos, setMostrarFiltroMontos] = useState(false);
  const [mostrarFiltroCliente, setMostrarFiltroCliente] = useState(false);
  const [mostrarFiltroMediosPago, setMostrarFiltroMediosPago] = useState(false);
  const [mostrarFiltroTipoTransaccion, setMostrarFiltroTipoTransaccion] = useState(false);
  const [mostrarTotales, setMostrarTotales] = useState(false);

  // Estados para filtros de atributos de entidad
  const [opcionesPorAtributo, setOpcionesPorAtributo] = useState({});
  const [atributosEntidadFiltro, setAtributosEntidadFiltro] = useState({});

  // Estados para modal de eliminación con comentario
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [deleteComentario, setDeleteComentario] = useState("");
  const [transaccionToDelete, setTransaccionToDelete] = useState(null);

  // Estado para mostrar transacciones eliminadas
  const [mostrarDeletes, setMostrarDeletes] = useState(false);

  // Estados para loading durante eliminación
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("Cargando...");

  useEffect(() => {
    const today = dayjs();
    setStartDate(today.subtract(30, "day"));
    setEndDate(today);
  }, []);

  useEffect(() => {
    getUbicacion();
  }, []);

  // Cargar datos iniciales
  useEffect(() => {
    const fetchDataInicio = async () => {
      try {
        // Cargar tipos de transacción primero (crítico para el componente)
        await getTipoTransaccion();
        await getMedioDePago();
        await getTransaccionTransformed();
        await getTipoMedioDePago();
        // No llamar getMedioDePagoIdTipoEspecifico aquí porque requiere un selectedTipoMedioDePago válido
        // Se llamará cuando el usuario seleccione un tipo de medio de pago
        // Cargar atributos de entidad si no están disponibles
        if (!entidadAtributoNoEliminados || entidadAtributoNoEliminados.length === 0) {
          await getEntidadAtributoNoEliminados();
        }
      } catch (error) {
        console.error("Error al cargar datos iniciales:", error);
      }
    };
    fetchDataInicio();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Verificar y recargar tipos de transacción si están vacíos (retry en caso de fallo inicial)
  useEffect(() => {
    const verificarYRecargar = async () => {
      // Esperar un momento para dar tiempo a la carga inicial
      await new Promise(resolve => setTimeout(resolve, 1000));
      
      // Si después de 1 segundo aún está vacío, intentar recargar
      if (!tipoTransaccion || tipoTransaccion.length === 0) {
        console.warn("tipoTransaccion está vacío, intentando recargar...");
        try {
          await getTipoTransaccion();
        } catch (error) {
          console.error("Error al recargar tipoTransaccion:", error);
        }
      }
    };
    
    verificarYRecargar();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Cargar opciones para cada atributo cuando cambian los atributos disponibles
  const cargarOpcionesAtributos = async () => {
    if (!entidadAtributoNoEliminados || entidadAtributoNoEliminados.length === 0) {
      setOpcionesPorAtributo({});
      return;
    }

    console.log("Cargando opciones para atributos:", entidadAtributoNoEliminados);
    const opcionesMap = {};
    for (const attr of entidadAtributoNoEliminados) {
      try {
        const opciones = await getEntidadAtributoClasificacionByIdAtributo(attr.id);
        opcionesMap[attr.id] = opciones || [];
        console.log(`Opciones para atributo ${attr.id} (${attr.descripcion}):`, opciones);
      } catch (error) {
        console.error(`Error al cargar opciones para atributo ${attr.id}:`, error);
        opcionesMap[attr.id] = [];
      }
    }
    console.log("Opciones por atributo cargadas:", opcionesMap);
    setOpcionesPorAtributo(opcionesMap);
  };

  // Inicializar opciones cuando se cargan los atributos disponibles
  useEffect(() => {
    if (entidadAtributoNoEliminados && entidadAtributoNoEliminados.length > 0) {
      cargarOpcionesAtributos();
    } else if (entidadAtributoNoEliminados && entidadAtributoNoEliminados.length === 0) {
      setOpcionesPorAtributo({});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [entidadAtributoNoEliminados]);

  useEffect(() => {
    const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
    const tipoMedioDePagoId = selectedTipoMedioDePago
      ? selectedTipoMedioDePago.id
      : null;
    const tipoTransaccionId = selectedTipoTransaccion
      ? selectedTipoTransaccion.id
      : null;
    const idEntidad = dniCliente ? dniCliente.id : null;
    const ubicacionId = selectedUbicacion ? selectedUbicacion.id : null;
    fetchData(
      startDate,
      endDate,
      medioDePagoId,
      tipoMedioDePagoId,
      tipoTransaccionId,
      page,
      idTransaccionSearch,
      idEntidad,
      ubicacionId,
      100,
      atributosEntidadFiltro,
      mostrarDeletes
    ); // Llamar a la función cada vez que cambia la página o la fecha
  }, [startDate, endDate, mostrarDeletes]); // Llamar cada vez que cambia la fecha, la página o mostrarDeletes

  useEffect(() => {
    const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
    const tipoMedioDePagoId = selectedTipoMedioDePago
      ? selectedTipoMedioDePago.id
      : null;
    const tipoTransaccionId = selectedTipoTransaccion
      ? selectedTipoTransaccion.id
      : null;
    const idEntidad = dniCliente ? dniCliente.id : null;
    const ubicacionId = selectedUbicacion ? selectedUbicacion.id : null;
    fetchData(
      startDate,
      endDate,
      medioDePagoId,
      tipoMedioDePagoId,
      tipoTransaccionId,
      page,
      idTransaccionSearch,
      idEntidad,
      ubicacionId,
      100,
      atributosEntidadFiltro,
      mostrarDeletes
    );
  }, [page]); // Llamar cada vez que cambia la fecha o la página

  const fetchData = async (
    startDate,
    endDate,
    idMedioPago,
    tipoMedioDePagoId,
    idTipoTransaccion,
    page,
    idTransaccionSearch,
    idEntidad,
    idUbicacion,
    limit = 100,
    atributosEntidadFiltro = {},
    incluirEliminados = false
  ) => {
    if (!startDate || !endDate) return;

    // ✅ Normalizar fechas con timezone usando getFechaHoraActualClient (patrón correcto)
    const validStartDate = startDate ? startDate : dayjs();
    const validEndDate = endDate ? endDate : dayjs();
    
    let formattedStartDate = validStartDate.format("YYYY-MM-DD");
    let formattedEndDate = validEndDate.format("YYYY-MM-DD");

    // Normalizar fechas con timezone del cliente
    const result1 = await getFechaHoraActualClient(formattedStartDate);
    const dateWithTimezoneStart = dayjs(result1.fechaServidor).startOf("day").toDate();

    const result2 = await getFechaHoraActualClient(formattedEndDate);
    const dateWithTimezoneEnd = dayjs(result2.fechaServidor).endOf("day").toDate();

    // Validar que las fechas sean válidas antes de enviar
    if (isNaN(dateWithTimezoneStart.getTime()) || isNaN(dateWithTimezoneEnd.getTime())) {
      console.error("Fechas inválidas generadas:", { dateWithTimezoneStart, dateWithTimezoneEnd, result1, result2 });
      return;
    }

    // Convertir atributosEntidadFiltro a atributoEntidad1, atributoEntidad2, etc.
    const atributosParams = {};
    Object.keys(atributosEntidadFiltro).forEach((key) => {
      const valor = atributosEntidadFiltro[key];
      if (valor) {
        atributosParams[`atributoEntidad${key}`] = valor;
      }
    });

    const data = await fetchFilteredTransactions(
      dateWithTimezoneStart,
      dateWithTimezoneEnd,
      idMedioPago,
      tipoMedioDePagoId,
      idTipoTransaccion,
      page,
      idTransaccionSearch,
      idEntidad,
      idUbicacion,
      limit,
      atributosParams,
      incluirEliminados
    );

    if (!data) {
      setTransaccionTransformedReforged([]);
      setTotalCount(0);
      setTotalPages(0);
      return;
    }

    // mapeo directo de la respuesta del back a las columnas
    const rows = data.data.map((tx) => {
      // Usar fecha (indicada por el usuario) en lugar de fechaHoraCreacion (cuando se creó el registro)
      // Si no hay fecha, usar fechaHoraCreacion como fallback
      const fechaCreada = new Intl.DateTimeFormat("es-AR", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      }).format(new Date(tx.fecha || tx.fechaHoraCreacion));

      console.log(tx)

      const pagos = (tx.pagos || []).map((p) => ({
        descripcion: p.medioDePago,
        monto: p.montoTotal,
        id: p.pagoId,
        idMedioPago: p.idMedio,
        idTipoMedio: p.idtipoMedio 
      }));

      const pagoSeleccionado = pagos.find(
        (pago) => pago.idMedioPago === idMedioPago
      );
      const montoRestante = pagoSeleccionado ? pagoSeleccionado.monto : 0;

      return {
        id: tx.id,
        updatedAtMod: fechaCreada,
        createdAt: fechaCreada, // Misma fecha que la tabla, para modales "Datos ERP"
        montoTotal: tx.montoTotal,
        idTipoTransaccion: tx.tipoTransaccion?.descripcion || "",
        idDelTipoTransaccion: tx.tipoTransaccion?.id || "",
        operacionCaja: tx.tipoTransaccion?.operacionCaja || null, // Operación de caja para coloración
        pagos,
        descripcionEntidad: tx.entidad?.descripcion || "",
        apellido: tx.entidad?.apellido || "",
        dniCuitCuil: tx.entidad?.dniCuitCuil || "",
        textoDescripcion: tx.descripcion || "",
        idEstadoDeCompra:
          tx.transaccionCompraEstado?.estadoCompra?.id ?? null,
        estadoDeCompra:
          tx.transaccionCompraEstado?.estadoCompra?.descripcion || "",
        idEntidadNumero: tx.entidad?.id || null, // ID de entidad para obtener detalles
        usuario: tx.usuario?.usuario || "",
        ubicacion: tx.ubicacion?.descripcion || "",
        negocio: tx.negocio?.descripcion || "",
        descripcionImpuestos: tx.descripcionImpuestos,
        montoRestante: montoRestante,
        descripcion: tx.descripcion,
        archivosAdjuntos: tx.archivosAdjuntos || null, // Archivos adjuntos
        impuestos: tx.impuestos || [], // Impuestos para cálculos
        montoDescuento: tx.montoDescuento || 0, // Descuentos
        porcentajeDescuento: tx.porcentajeDescuento || 0, // Porcentaje de descuento
        afectaCuentaCorriente: tx.afectaCuentaCorriente || false, // Afecta cuenta corriente
        eliminado: tx.eliminado || false, // Estado de eliminado
        usuarioElimino: tx.usuarioElimino || null, // Usuario que eliminó (si aplica)

        // cualquier otro campo que uses en columnas…
      };
    });

    setTransaccionTransformedReforged(rows);
    setTotalCount(data.totalCount);
    setTotalPages(data.totalPages);
    const totalesPorTipoData = calcularTotalesPorTipo(rows);
    
    // ✅ Usar totales globales del backend si están disponibles, sino calcular localmente
    const totalesPorTipoMedioDePagoData = data.totalesGlobales 
      ? data.totalesGlobales 
      : calcularTotalesPorTipoMedioDePago(data.data);
    
    setTotalesPorTipoMedioDePago(totalesPorTipoMedioDePagoData);
    setTotalesPorTipo(totalesPorTipoData);
  };

  useEffect(() => {
    if (searchTextCliente.length >= 3) {
      getEntidadesClientesTresLetras(searchTextCliente, null); // null para obtener todas las entidades (clientes, proveedores, etc.)
    }
  }, [searchTextCliente]);

  // Estado para las filas seleccionadas
  const [selectedRows, setSelectedRows] = useState([]);

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 70,
      flex: 0.5,
      headerAlign: "center",
    },
    {
      field: "updatedAtMod",
      headerName: "Fecha",
      width: 200,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "montoTotal",
      headerName: "Monto",
      type: "number",
      width: 130,
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => {
        let color = "#4CAF50"; // Verde por defecto

        // Usar operacionCaja para determinar el color
        const operacionCaja = params.row.operacionCaja;
        
        if (operacionCaja === "+") {
          color = "#4CAF50"; // Verde para ingresos
        } else if (operacionCaja === "-") {
          color = "#FF9800"; // Naranja para egresos
        } else if (operacionCaja === null || operacionCaja === undefined || operacionCaja === "") {
          color = "gray"; // Gris para operaciones sin efecto en caja
        }
        
        return (
          <span style={{ color, fontWeight: "bold" }}>
            ${params.value?.toLocaleString("es-AR") || "0.00"}
          </span>
        );
      },
    },
    ...(selectedMedioDePago
      ? [
          {
            field: "montoRestante",
            headerName: "Monto Pago Seleccionado",
            type: "number",
            width: 150,
            flex: 1,
            headerAlign: "center",
            renderCell: (params) => {
              let color = "#4CAF50"; // Verde por defecto

              // Usar operacionCaja para determinar el color
              const operacionCaja = params.row.operacionCaja;
              
              if (operacionCaja === "+") {
                color = "#4CAF50"; // Verde para ingresos
              } else if (operacionCaja === "-") {
                color = "#FF9800"; // Naranja para egresos
              } else if (operacionCaja === null || operacionCaja === undefined || operacionCaja === "") {
                color = "gray"; // Gris para operaciones sin efecto en caja
              }
              
              return (
                <span style={{ color, fontWeight: "bold" }}>
                  ${params.value?.toLocaleString("es-AR") || "0.00"}
                </span>
              );
            },
          },
        ]
      : []), // Devuelve un array vacío en lugar de [{}]
    //{ field: "idMoneda", headerName: "Moneda", width: 90 },
    { field: "idTipoTransaccion", headerName: "Tipo Transacción", width: 150 },
    {
      field: "pagos",
      headerName: "Medio de Pago",
      width: 150,
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => {
        const pagos = Array.isArray(params.row.pagos) ? params.row.pagos : [];
    
        if (pagos.length > 1) {
          // Mostrar múltiples medios de pago
          return (
            <div>
              <span style={{ fontWeight: "bold", color: "blue" }}>
                Múltiple
              </span>
            </div>
          );
        } else {
          // Mostrar un solo medio de pago
          return (
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ fontWeight: "bold", color: "#00AAE4" }}>
                {pagos[0]?.descripcion || "N/A"}
              </span>
            </div>
          );
        }
      },
    },
    {
      field: "descripcionEntidad",
      headerName: "Entidad",
      width: 150,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "usuario",
      headerName: "Usuario",
      width: 150,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "ubicacion",
      headerName: "Ubicación",
      width: 150,
      flex: 1,
      headerAlign: "center",
    },
    {
      field: "action",
      headerName: "Acciones",
      width: 180,
      flex: 1,
      headerAlign: "center",
      renderCell: (params) => (
        <>
          <IconButton
            className="colorGeneralParaIconos"
            onClick={() => handleOpenModal(params.row)}
          >
            <VisibilityIcon />
          </IconButton>
          <IconButton
            className="colorGeneralParaIconos"
            onClick={() => handleDownloadPDF(params.row)}
          >
            <PictureAsPdfIcon />
          </IconButton>
          {params.row.idTipoTransaccion === "Venta" ? (
            <IconButton
              className="colorGeneralParaIconos"
              onClick={() => handleDownloadRemito(params.row)}
            >
              <ReceiptLongIcon />
            </IconButton>
          ) : null}

          {/* Botón Eliminar Transacción - Solo visible si tiene permiso, la transacción NO está eliminada Y NO se está mostrando la vista de eliminados */}
          {tieneAccesoFuncionalidad(user, 'TRANSACCIONES5', 'btnEliminarTransaccionVerTransacciones') && 
           !params.row.eliminado && 
           !mostrarDeletes && (
            <Tooltip title="Borrar Transaccion">
              <IconButton
                className="colorGeneralParaIconos"
                onClick={() => borrarTransaccion(params.row)}
                size="small"
                sx={{
                  bgcolor: "rgb(244, 177, 14, 0.2)",
                  "&:hover": "rgb(244, 177, 14, 0.2)",
                }}
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
    // Columna de usuario que eliminó (solo visible cuando se muestran eliminados)
    ...(mostrarDeletes ? [{
      field: "usuarioElimino",
      headerName: "Eliminado por",
      flex: 0.8,
      minWidth: 150,
      headerAlign: "center",
      sortable: true,
      renderCell: (params) => {
        if (!params.value) return <span style={{ fontStyle: "italic", color: "#999" }}>Sin información</span>;
        return <Typography variant="body2" sx={{ fontStyle: "italic" }}>{params.value}</Typography>;
      },
    }] : []),
  ];

  const calcularTotalesPorTipo = (data) => {
    const totales = {
      Venta: 0,
      Presupuesto: 0,
      Compra: 0,
      Ingreso: 0,
      Egreso: 0,
    };

    data.forEach((transaccion) => {
      const tipo = transaccion.idTipoTransaccion;
      if (totales[tipo] !== undefined) {
        console.log(totales[tipo]);

        totales[tipo] += transaccion.montoRestante;
      }
    });

    return totales;
  };

const calcularTotalesPorTipoMedioDePago = (data) => {
  const totales = {
    Venta: 0,
    Presupuesto: 0,
    Compra: 0,
    Ingreso: 0,
    Egreso: 0,
  };

  data.forEach((transaccion) => {
    const tipo = transaccion.tipoTransaccion.descripcion;
    if (totales[tipo] !== undefined) {
      // Aplico Math.abs() al monto antes de sumar
      totales[tipo] += Math.abs(transaccion.montoTotal);
    }
  });

  return totales;
};

  // Calcula los totales por tipo de transacción

  const handleDownloadPDF = async (transaccionRow) => {
    const transaccionEncontrada = await getTransaccionItemID(transaccionRow.id); // Obtener los items de la transacción
    // Solo obtener la entidad si existe un ID válido
    let entidadCliente = null;
    if (transaccionRow.idEntidadNumero && transaccionRow.idEntidadNumero !== null) {
      try {
        entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero);
      } catch (error) {
        console.error("Error al obtener entidad para PDF:", error);
        entidadCliente = null;
      }
    }

    // Estructurar itemsTransaccion con datos completos

    /* HARDCODED WARNING ESTO PUEDE AFECTAR CUANDO HAYA MAS DE UNA UBICION PARA LOS ITEMS! */
    const itemsTransaccion = await Promise.all(
      transaccionEncontrada.map(async (transItem) => {
        const foundItem = await getItemById(transItem.idItem);

        // O si necesitas concatenarlo:
        const precio = transItem.precio;
        return {
          idItem: transItem.idItem,
          codigo: foundItem ? foundItem.codigo : "N/A",
          descripcion: foundItem
            ? foundItem.descripcion
            : "Descripción no disponible",
          cantidad: transItem.cantidad || 0,
          precio: transItem ? transItem.precio : 0,
          porcentajeDescuento: transItem ? transItem.porcentajeDescuento : 0,
          porcentajeInteres: transItem ? transItem.porcentajeInteres || 0 : 0,
          total: transItem
            ? (
                transItem.precio *
                transItem.cantidad *
                (1 - (transItem.porcentajeDescuento || 0) / 100) *
                (1 + (transItem.porcentajeInteres || 0) / 100)
              ).toFixed(2)
            : "0.00",
        };
      })
    );
    // Llamar a la función en el contexto para generar el PDF con "tablaVenta"
    generarFacturaPDF(
      transaccionRow,
      itemsTransaccion,
      entidadCliente,
      "tablaVenta",
      transaccionRow.impuestos
    );
  };

  const borrarTransaccion = (transaccionRow) => {
    setTransaccionToDelete(transaccionRow);
    setDeleteComentario("");
    setOpenDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!transaccionToDelete) return;

    // Validar que el comentario no esté vacío
    if (!deleteComentario.trim()) {
      Swal.fire({
        title: "Campo requerido",
        text: "Debes proporcionar un motivo para eliminar la transacción.",
        icon: "warning",
        confirmButtonColor: "#f4b10e",
      });
      return;
    }

    // Cerrar modal de eliminación antes de mostrar loading
    setOpenDeleteModal(false);

    try {
      setLoading(true);
      
      // ✅ PASO 1: Verificar si la transacción afecta cuenta corriente
      let afectaCuentaCorriente = false;
      let entidadNombre = null;
      
      try {
        setLoadingMessage("(1/4) Verificando cuenta corriente...");
        
        // Verificar si tiene flag de cuenta corriente
        if (transaccionToDelete.afectaCuentaCorriente) {
          afectaCuentaCorriente = true;
        }
        
        // O si tiene pagos que afectan cuenta corriente
        if (transaccionToDelete.pagos && Array.isArray(transaccionToDelete.pagos)) {
          const tieneCC = transaccionToDelete.pagos.some(pago => 
            pago.medioDePago?.tipoMedioDePago?.afectaCuentaCorriente === true
          );
          if (tieneCC) {
            afectaCuentaCorriente = true;
          }
        }
        
        // Obtener nombre de la entidad
        if (afectaCuentaCorriente && transaccionToDelete.idEntidadNumero) {
          try {
            const entidad = await getEntidadByID(transaccionToDelete.idEntidadNumero);
            if (entidad) {
              entidadNombre = `${entidad.descripcion || ''} ${entidad.apellido || ''}`.trim();
            }
          } catch (err) {
            console.log("No se pudo obtener entidad:", err);
          }
        }
      } catch (ccError) {
        console.log("Error verificando CC:", ccError);
      }
      
      // ✅ PASO 2: Eliminar transacción
      setLoadingMessage("(2/4) Eliminando transacción...");
      
      // Guardar datos de la transacción ANTES de eliminar (para recalcular caja)
      const fechaTransaccion = transaccionToDelete.updatedAtMod; // Fecha formateada de la transacción
      const idUbicacionTransaccion = transaccionToDelete.idUbicacion;
      const zona = Intl.DateTimeFormat().resolvedOptions().timeZone;
      
      // Guardar auditoría antes de eliminar
      if (user && user.id) {
        await postTransaccionAuditoria(
          transaccionToDelete.id,
          user.id,
          deleteComentario.trim(),
          "eliminar"
        );
      }

      // Eliminar la transacción
      await updateDeleteTransaccion(transaccionToDelete.id);
      
      // ✅ PASO 3: Actualizar cuenta corriente (si aplica)
      if (afectaCuentaCorriente) {
        setLoadingMessage("(3/4) Actualizando cuenta corriente...");
        // El backend ya se encargó de actualizar la CC en updateDeleteTransaccion
        // Solo esperamos un momento para dar feedback visual
        await new Promise(resolve => setTimeout(resolve, 500));
      }
      
      // ✅ PASO 4: Recalcular caja
      setLoadingMessage(`(${afectaCuentaCorriente ? '4/4' : '3/4'}) Recalculando caja...`);
      
      try {
        // Obtener fecha actual para recálculo
        const fechaHoy = dayjs().format('YYYY-MM-DD');
        
        // Determinar ubicación para recalcular
        // Prioridad: ubicación filtrada > ubicación de transacción > todas
        const ubicacionParaRecalculo = selectedUbicacion?.id || idUbicacionTransaccion || 'todas';
        
        // Recalcular caja desde esa fecha hasta hoy
        await getAndPostCajaDatos(
          fechaHoy,              // Fecha de la transacción eliminada
          zona,                  // Zona horaria
          ubicacionParaRecalculo, // Ubicación específica o 'todas'
          "update"               // ⭐ Modo UPDATE para recalcular desde esa fecha
        );
        
        console.log(`✅ Caja recalculada para ubicación ${ubicacionParaRecalculo}`);
      } catch (cajaError) {
        console.error("⚠️ Error al recalcular caja:", cajaError);
        // No bloqueamos el flujo si falla el recalculo de caja
        // La transacción ya fue eliminada exitosamente
      }
      
      // Limpiar estados
      setTransaccionToDelete(null);
      setDeleteComentario("");
      
      // Refrescar datos
      setLoadingMessage("Actualizando tabla...");
      const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
      const tipoTransaccionId = selectedTipoTransaccion ? selectedTipoTransaccion.id : null;
      const tipoMedioDePagoId = selectedTipoMedioDePago ? selectedTipoMedioDePago.id : null;
      const idEntidad = dniCliente ? dniCliente.id : null;
      const ubicacionId = selectedUbicacion ? selectedUbicacion.id : null;

      await fetchData(
        startDate,
        endDate,
        medioDePagoId,
        tipoMedioDePagoId,
        tipoTransaccionId,
        page,
        idTransaccionSearch,
        idEntidad,
        ubicacionId,
        100,
        atributosEntidadFiltro,
        mostrarDeletes
      );
      
      setLoading(false);
      
      // ✅ Mensaje personalizado según si afectó cuenta corriente
      let mensajeExito = `La transacción ${transaccionToDelete.id} ha sido eliminada correctamente.`;
      
      if (afectaCuentaCorriente) {
        mensajeExito += `\n\n💳 La cuenta corriente ${entidadNombre ? 'de ' + entidadNombre : ''} ha sido actualizada automáticamente.`;
      }

      Swal.fire({
        title: "¡Eliminado!",
        text: mensajeExito,
        icon: "success",
        confirmButtonColor: "#4caf50",
        timer: afectaCuentaCorriente ? 4000 : 2000,
        showConfirmButton: afectaCuentaCorriente,
      });
    } catch (error) {
      console.error("Error al borrar transacción:", error);
      setLoading(false);
      setTransaccionToDelete(null);
      setDeleteComentario("");
      Swal.fire({
        title: "Error",
        text: "No se pudo eliminar la transacción. Intenta de nuevo.",
        icon: "error",
      });
    }
  };

  const handleCancelDelete = () => {
    setOpenDeleteModal(false);
    setTransaccionToDelete(null);
    setDeleteComentario("");
  };

  const handleDownloadRemito = async (transaccionRow) => {
    try {
      const transaccionEncontrada = await getTransaccionItemID(transaccionRow.id, false);
      const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero);

      let cuentaCorrienteInfo = null;
      try {
        const cuentas = await getCuentaCorrienteByIdEntidad(entidadCliente?.id);
        const cuenta =
          cuentas && cuentas.length > 0
            ? cuentas.find((ct) => ct.idEntidad === entidadCliente?.id)
            : null;

        if (cuenta) {
          cuentaCorrienteInfo = {
            saldo: cuenta.saldo,
            tieneCuentaCorriente: true,
          };
        } else {
          cuentaCorrienteInfo = {
            saldo: 0,
            tieneCuentaCorriente: false,
          };
        }
      } catch (error) {
        cuentaCorrienteInfo = {
          saldo: 0,
          tieneCuentaCorriente: false,
        };
      }

      const itemsTransaccion = await Promise.all(
        transaccionEncontrada.map(async (transItem) => {
          const foundItem = await getItemById(transItem.idItem);
          const precio = transItem.precio || 0;
          return {
            codigo: foundItem ? foundItem.codigo : "N/A",
            descripcion: foundItem ? foundItem.descripcion : "Descripción no disponible",
            cantidad: transItem.cantidad || 0,
            precio,
            porcentajeDescuento: transItem.porcentajeDescuento || 0,
            porcentajeInteres: transItem.porcentajeInteres || 0,
            total: (
              precio *
              (transItem.cantidad || 0) *
              (1 - (transItem.porcentajeDescuento || 0) / 100) *
              (1 + (transItem.porcentajeInteres || 0) / 100)
            ).toFixed(2),
          };
        }),
      );

      const tipoFacturaDescripcion =
        transaccionRow.tipoFacturaDescripcion != "" ? false : true;

      await generarRemitoPDF(
        transaccionRow,
        itemsTransaccion,
        entidadCliente,
        transaccionRow.usuario,
        tipoFacturaDescripcion,
        transaccionRow.impuestos,
        cuentaCorrienteInfo,
      );
    } catch (error) {
      console.error("Error al generar remito:", error);
    }
  };

  const [calculatedTotal, setCalculatedTotal] = useState(null); // Para almacenar el monto calculado
  const [totalMontoDescuento, setTotalMontoDescuento] = useState(null); // Para almacenar el monto calculado
  const [totalPorcentajeDescuento, setPorcentajeDescuento] = useState(null); // Para almacenar el monto calculado
  const [montoSinImpuesto, setMontoSinImpuesto] = useState(null); // Para almacenar el monto calculado

  const handleOpenModal = async (transaccionRow) => {
    setSelectedTransaccion(transaccionRow);
    // Solo obtener la entidad si existe un ID válido
    if (transaccionRow.idEntidadNumero && transaccionRow.idEntidadNumero !== null) {
      try {
    const entidadCliente = await getEntidadByID(transaccionRow.idEntidadNumero);
    setSelectedTransaccionEntidad(entidadCliente);
      } catch (error) {
        console.error("Error al obtener entidad:", error);
        setSelectedTransaccionEntidad(null);
      }
    } else {
      setSelectedTransaccionEntidad(null);
    }

    const {
      montoTotal,
      impuestos = [],
      montoDescuento = 0,
      porcentajeDescuento = 0,
    } = transaccionRow;
    const totalSinImpuestos = impuestos.reduce(
      (total, impuesto) => total - (impuesto.montoTotal || 0),
      montoTotal
    );
    const totalSinImpuestosYDescuento = totalSinImpuestos + montoDescuento;
    const totalFinal =
      totalSinImpuestosYDescuento * (1 - porcentajeDescuento / 100);

    setCalculatedTotal(totalFinal);
    setTotalMontoDescuento(montoDescuento);
    setPorcentajeDescuento(porcentajeDescuento);
    setMontoSinImpuesto(totalSinImpuestos);

    if (transaccionRow.idDelTipoTransaccion === 2) {
      try {
        const payload = await getTransaccionItemIDEnCompras(
          transaccionRow.id
        );
        if (
          payload &&
          typeof payload === "object" &&
          !Array.isArray(payload)
        ) {
          setTransaccionItems(
            Array.isArray(payload.items) ? payload.items : []
          );
          setCompraItems(
            Array.isArray(payload.compraItems) ? payload.compraItems : []
          );
        } else {
          setTransaccionItems([]);
          setCompraItems([]);
        }
      } catch (e) {
        console.error("Error al cargar ítems de compra:", e);
        setTransaccionItems([]);
        setCompraItems([]);
      }
    }

    switch (transaccionRow.idDelTipoTransaccion) {
      case 1:
        setOpenModalVenta(true);
        break;
      case 2:
        setOpenModalCompra(true);
        break;
      case 3:
        setOpenModalPresupuesto(true);
        break;
      case 4:
        setOpenModalIngreso(true);
        break;
      case 5:
        setOpenModalEgreso(true);
        break;
      case 6:
        setOpenModalDevolucion(true);
        break;
      default:
        // Modal genérico para tipos de transacción nuevos o personalizados
        setOpenModalGenerico(true);
        break;
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setOpenModalVenta(false);
    setOpenModalCompra(false);
    setOpenModalPresupuesto(false);
    setOpenModalIngreso(false);
    setOpenModalEgreso(false);
    setOpenModalDevolucion(false);
    setOpenModalGenerico(false);
    setTransaccionItems([]);
    setCompraItems([]);
  };

  const handleFilter = async () => {
    try {
      const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
      const tipoMedioDePagoId = selectedTipoMedioDePago
        ? selectedTipoMedioDePago.id
        : null;
      const tipoTransaccionId = selectedTipoTransaccion
        ? selectedTipoTransaccion.id
        : null;
      const idEntidad = dniCliente ? dniCliente.id : null;
      const ubicacionId = selectedUbicacion ? selectedUbicacion.id : null;
      fetchData(
        startDate,
        endDate,
        medioDePagoId,
        tipoMedioDePagoId,
        tipoTransaccionId,
        page,
        idTransaccionSearch,
        idEntidad,
        ubicacionId,
        100,
        atributosEntidadFiltro,
        mostrarDeletes
      );
    } catch (error) {}
  };

  const resetFilters = () => {
    setDniCliente(null);
    setSearchTextCliente("");
    setIdTransaccionSearch("");
    setSelectedTipoMedioDePago(null);
    setSelectedMedioDePago(null);
    setSelectedTipoTransaccion(null);
    setSelectedUbicacion(null);
    setMostrarFiltroMontos(false);
    setMostrarFiltroCliente(false);
    setMostrarFiltroMediosPago(false);
    setMostrarFiltroTipoTransaccion(false);
    setAtributosEntidadFiltro({});

    // Mantener solo la fecha de inicio como hoy
    const today = dayjs();
    setStartDate(today.subtract(30, "day"));
    setEndDate(today);

    // Refrescar datos con filtros reseteados
    fetchData(startDate, endDate, null, null, null, null, null, null, null, 100, {}, mostrarDeletes);
  };

  const handleTipoMedioDePagoChange = (tipo) => {
    setSelectedTipoMedioDePago(tipo);

    if (tipo.id === 7) {
      // Si el tipo es múltiple, deshabilitar el medio de pago individual
      setSelectedMedioDePago(null);
    }
  };

  const deleteDate1 = () => {
    setStartDate(null);
  };
  const deleteDate2 = () => {
    setEndDate(null);
  };

  // ===== Control del menú lateral =====
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Función para alternar filtros y cerrar otros
  const toggleFiltro = (filtroNombre) => {
    switch (filtroNombre) {
      case 'montos':
        setMostrarFiltroMontos(!mostrarFiltroMontos);
        setMostrarFiltroCliente(false);
        setMostrarFiltroMediosPago(false);
        setMostrarFiltroTipoTransaccion(false);
        break;
      case 'cliente':
        setMostrarFiltroCliente(!mostrarFiltroCliente);
        setMostrarFiltroMontos(false);
        setMostrarFiltroMediosPago(false);
        setMostrarFiltroTipoTransaccion(false);
        break;
      case 'mediosPago':
        setMostrarFiltroMediosPago(!mostrarFiltroMediosPago);
        setMostrarFiltroMontos(false);
        setMostrarFiltroCliente(false);
        setMostrarFiltroTipoTransaccion(false);
        break;
      case 'tipoTransaccion':
        setMostrarFiltroTipoTransaccion(!mostrarFiltroTipoTransaccion);
        setMostrarFiltroMontos(false);
        setMostrarFiltroCliente(false);
        setMostrarFiltroMediosPago(false);
        break;
      default:
        break;
    }
  };

  // Funciones para manipular fechas
  const increaseDate = () => setStartDate((prev) => (prev ? prev.add(1, "day") : dayjs()));
  const decreaseDate = () => setStartDate((prev) => (prev ? prev.subtract(1, "day") : dayjs()));

  useEffect(() => {
    // Solo llamar si hay un tipo de medio de pago seleccionado válido
    if (selectedTipoMedioDePago && selectedTipoMedioDePago.id) {
    getMedioDePagoIdTipoEspecifico(selectedTipoMedioDePago);
    }
  }, [selectedTipoMedioDePago]);

  // Detectar filtros activos
  useEffect(() => {
    const hasActiveFilters = 
      dniCliente || 
      selectedUbicacion || 
      selectedTipoMedioDePago || 
      selectedMedioDePago || 
      selectedTipoTransaccion ||
      idTransaccionSearch ||
      Object.values(atributosEntidadFiltro).some(v => v);
    setFiltersActive(hasActiveFilters);
  }, [dniCliente, selectedUbicacion, selectedTipoMedioDePago, selectedMedioDePago, selectedTipoTransaccion, idTransaccionSearch, atributosEntidadFiltro]);

  // Función para renderizar el contenido de los filtros (reutilizable)
  const renderFiltrosContent = () => (
    <>
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 2,
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: isLaptopDown ? "column" : "row",
        }}
      >
        {/* Filtro de fechas - PRIMERA PRIORIDAD */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1.2, flex: 1, minWidth: isLaptopDown ? "100%" : 250, width: isLaptopDown ? "100%" : "auto" }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <IconButton onClick={decreaseDate} color="primary" size="small">
              <ArrowBackIcon fontSize="small" />
            </IconButton>
            <DatePicker
              value={startDate}
              onChange={(newValue) => setStartDate(newValue)}
              format="DD/MM/YYYY"
              label="Desde"
              slotProps={{ textField: { size: "small", inputProps: { maxLength: 10 }, fullWidth: isLaptopDown } }}
              sx={{ flex: 1 }}
            />
            <DatePicker
              value={endDate}
              onChange={(newValue) => setEndDate(newValue)}
              format="DD/MM/YYYY"
              label="Hasta"
              slotProps={{ textField: { size: "small", inputProps: { maxLength: 10 }, fullWidth: isLaptopDown } }}
              sx={{ flex: 1 }}
            />
            <IconButton onClick={increaseDate} color="primary" size="small">
              <ArrowForwardIcon fontSize="small" />
            </IconButton>
          </LocalizationProvider>
        </Box>

        {/* Filtro de ID, ubicación y entidad - SEGUNDA PRIORIDAD */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, flex: 2, minWidth: isLaptopDown ? "100%" : 300, width: isLaptopDown ? "100%" : "auto", flexDirection: isLaptopDown ? "column" : "row" }}>
          <TextField
            label="Buscar por ID"
            type="number"
            size="small"
            value={idTransaccionSearch || ""}
            onChange={(e) => setIdTransaccionSearch(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
            sx={{ width: isLaptopDown ? "100%" : "20%" }}
            fullWidth={isLaptopDown}
          />
          <Autocomplete
            size="small"
            disablePortal
            options={ubicaciones.map((it) => ({ id: it.id, label: it.descripcion }))}
            value={selectedUbicacion}
            onChange={(event, newValue) => setSelectedUbicacion(newValue)}
            sx={{ flex: 1, width: isLaptopDown ? "100%" : "auto" }}
            renderInput={(params) => <TextField {...params} label="Ubicación" variant="outlined" />}
          />
          <Autocomplete
            size="small"
            disablePortal
            options={entidadesClientesTresLetras.map((it) => ({
              label: `${it.descripcion} - ${it.apellido} - ${it.dniCuitCuil}`,
              ...it,
            }))}
            value={dniCliente}
            onChange={(event, newValue) => setDniCliente(newValue || null)}
            onInputChange={(event, newInputValue) => setSearchTextCliente(newInputValue)}
            sx={{ flex: 1, width: isLaptopDown ? "100%" : "auto" }}
            renderInput={(params) => <TextField {...params} label="Entidad - DNI / CUIT / CUIL" variant="outlined" />}
          />
        </Box>

        {/* Botones de acción (solo desktop) */}
        {!isLaptopDown && (
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Button
              variant="contained"
              size="small"
              onClick={handleFilter}
              startIcon={<SearchIcon />}
              sx={{
                backgroundColor: "#5b5b5f",
                textTransform: "none",
                padding: "8px 16px",
                color: "white",
                "&:hover": { backgroundColor: alpha("rgb(244, 177, 14)", 0.8) },
              }}
            >
              Buscar
            </Button>

            <Tooltip title={filtersActive ? "Resetear filtros" : "Refrescar"}>
              <IconButton
                onClick={resetFilters}
                color="primary"
                size="small"
                sx={{
                  bgcolor: filtersActive ? alpha(theme.palette.secondary?.main || "#f0f0f0", 0.1) : "transparent",
                  "&:hover": {
                    bgcolor: alpha(theme.palette.secondary?.main || "#f0f0f0", 0.2),
                  },
                }}
              >
                <ReplayIcon />
              </IconButton>
            </Tooltip>

            <Tooltip title={sidebarOpen ? "Cerrar Más Filtros" : "Mostrar Más Filtros"}>
              <Badge 
                badgeContent={
                  (selectedTipoMedioDePago || selectedMedioDePago ? 1 : 0) +
                  (selectedTipoTransaccion ? 1 : 0) +
                  (Object.values(atributosEntidadFiltro).filter(v => v).length > 0 ? 1 : 0)
                } 
                color="secondary"
              >
                <IconButton
                  onClick={toggleSidebar}
                  color="primary"
                  size="small"
                  sx={{
                    bgcolor: sidebarOpen ? alpha(theme.palette.secondary?.main || "#f0f0f0", 0.1) : "transparent",
                    "&:hover": { bgcolor: alpha(theme.palette.secondary?.main || "#f0f0f0", 0.2) },
                  }}
                >
                  <TuneIcon />
                </IconButton>
              </Badge>
            </Tooltip>
          </Box>
        )}
      </Box>

      {/* Chips de filtros activos (debajo del menú principal) */}
      {!isLaptopDown && (dniCliente || selectedUbicacion || selectedTipoMedioDePago || selectedMedioDePago || selectedTipoTransaccion || Object.values(atributosEntidadFiltro).some(v => v)) && (
        <Box
          sx={{
            px: 0,
            pt: 2,
            pb: 0,
            display: "flex",
            flexWrap: "wrap",
            gap: 1,
            alignItems: "center",
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            mt: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 600, mr: 1, color: theme.palette.text.secondary }}>
            Filtros activos:
          </Typography>
          
          {/* Chip de Cliente */}
          {dniCliente && (
            <Chip
              label={`Cliente: ${dniCliente.descripcion || dniCliente.label || dniCliente.dniCuitCuil || ""}`}
              size="small"
              onDelete={() => {
                setDniCliente(null);
                setSearchTextCliente("");
                setMostrarFiltroCliente(false);
                handleFilter();
              }}
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            />
          )}

          {/* Chip de Ubicación */}
          {selectedUbicacion && (
            <Chip
              label={`Ubicación: ${selectedUbicacion.label || selectedUbicacion.descripcion || ""}`}
              size="small"
              onDelete={() => {
                setSelectedUbicacion(null);
                handleFilter();
              }}
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            />
          )}

          {/* Chip de Tipo de Transacción */}
          {selectedTipoTransaccion && (
            <Chip
              label={`Tipo: ${selectedTipoTransaccion.descripcion || ""}`}
              size="small"
              onDelete={() => {
                setSelectedTipoTransaccion(null);
                handleFilter();
              }}
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            />
          )}

          {/* Chip de Tipo Medio de Pago */}
          {selectedTipoMedioDePago && (
            <Chip
              label={`Tipo Pago: ${selectedTipoMedioDePago.descripcion || ""}`}
              size="small"
              onDelete={() => {
                setSelectedTipoMedioDePago(null);
                setSelectedMedioDePago(null);
                handleFilter();
              }}
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            />
          )}

          {/* Chip de Medio de Pago */}
          {selectedMedioDePago && (
            <Chip
              label={`Medio: ${selectedMedioDePago.descripcion || ""}`}
              size="small"
              onDelete={() => {
                setSelectedMedioDePago(null);
                handleFilter();
              }}
              sx={{
                backgroundColor: alpha(theme.palette.primary.main, 0.1),
                color: theme.palette.primary.main,
                fontWeight: 500,
              }}
            />
          )}

          {/* Chips de Atributos de Entidad */}
          {entidadAtributoNoEliminados && entidadAtributoNoEliminados.length > 0 && entidadAtributoNoEliminados.map((atributo, index) => {
            const atributoNumero = index + 1;
            const valorAtributo = atributosEntidadFiltro[atributoNumero];
            if (!valorAtributo) return null;
            
            const opciones = opcionesPorAtributo[atributo.id] || [];
            const opcionSeleccionada = opciones.find(o => o.id === valorAtributo);
            
            return (
              <Chip
                key={atributo.id}
                label={`${atributo.descripcion}: ${opcionSeleccionada?.descripcion || "N/A"}`}
                size="small"
                onDelete={() => {
                  setAtributosEntidadFiltro(prev => {
                    const newAtributos = { ...prev };
                    delete newAtributos[atributoNumero];
                    return newAtributos;
                  });
                  handleFilter();
                }}
                sx={{
                  backgroundColor: alpha(theme.palette.secondary.main, 0.1),
                  color: theme.palette.secondary.main,
                  fontWeight: 500,
                }}
              />
            );
          })}
        </Box>
      )}

      {/* Boxes de filtros expandibles (debajo del menú principal) */}
      {!isLaptopDown && (mostrarFiltroCliente || mostrarFiltroMediosPago || mostrarFiltroTipoTransaccion) && (
        <Box
          sx={{
            px: 0,
            pt: 2,
            pb: 0,
            display: "flex",
            flexDirection: "column",
            gap: 2,
            borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
            mt: 2,
          }}
        >
          {/* Subbox de Atributos de Entidad */}
          {mostrarFiltroCliente && (
            <Paper
              elevation={2}
              sx={{
                p: 2,
                backgroundColor: alpha(theme.palette.background.default, 0.5),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 600, color: "#5b5b5f" }}>
                  <PersonIcon fontSize="small" sx={{ color: "rgb(244, 177, 14)" }} />
                  Filtrar por Atributos de Entidad
                </Typography>
                <IconButton size="small" onClick={() => setMostrarFiltroCliente(false)} sx={{ color: "#5b5b5f" }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
              
              {/* Filtros de Atributos de Entidad */}
              <Box sx={{ mb: 2 }}>
                {entidadAtributoNoEliminados && entidadAtributoNoEliminados.length > 0 && (
                  <Chip 
                    label={`${entidadAtributoNoEliminados.length} atributos disponibles`} 
                    size="small" 
                    sx={{ mb: 2, color: "#5b5b5f" }} 
                  />
                )}
                
                {(() => {
                  const tieneAtributos = entidadAtributoNoEliminados && Array.isArray(entidadAtributoNoEliminados) && entidadAtributoNoEliminados.length > 0;
                  console.log("Renderizando filtros de atributos - tieneAtributos:", tieneAtributos, "entidadAtributoNoEliminados:", entidadAtributoNoEliminados);
                  
                  if (!tieneAtributos) {
                    return (
                      <Typography variant="caption" sx={{ color: theme.palette.text.secondary, fontStyle: "italic" }}>
                        No hay atributos de entidad configurados. Ve a Administración → Atributos de Entidad para configurarlos.
                      </Typography>
                    );
                  }
                  
                  return (
                    <Box
                      sx={{
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr", md: "repeat(3, 1fr)", lg: "repeat(4, 1fr)" },
                        gap: 2,
                      }}
                    >
                      {entidadAtributoNoEliminados.map((atributo, index) => {
                        const atributoNumero = index + 1;
                        const opciones = opcionesPorAtributo[atributo.id] || [];
                        
                        return (
                          <Autocomplete
                            key={atributo.id}
                            size="small"
                            disablePortal
                            options={opciones}
                            getOptionLabel={(option) => option.descripcion || ""}
                            value={opciones.find(o => o.id === atributosEntidadFiltro[atributoNumero]) || null}
                            onChange={(event, newValue) => {
                              setAtributosEntidadFiltro(prev => {
                                const newAtributos = { ...prev };
                                if (newValue) {
                                  newAtributos[atributoNumero] = newValue.id;
                                } else {
                                  delete newAtributos[atributoNumero];
                                }
                                return newAtributos;
                              });
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label={atributo.descripcion}
                                variant="outlined"
                                size="small"
                                InputProps={{
                                  ...params.InputProps,
                                  startAdornment: (
                                    <>
                                      <InputAdornment position="start">
                                        <PersonIcon fontSize="small" sx={{ color: "rgb(244, 177, 14)" }} />
                                      </InputAdornment>
                                      {params.InputProps.startAdornment}
                                    </>
                                  ),
                                }}
                                sx={{
                                  "& .MuiOutlinedInput-root": {
                                    backgroundColor: atributosEntidadFiltro[atributoNumero]
                                      ? alpha(theme.palette.secondary.main, 0.05)
                                      : "white",
                                  },
                                }}
                              />
                            )}
                          />
                        );
                      })}
                    </Box>
                  );
                })()}
              </Box>

              {/* Botones de Acción */}
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 2 }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleFilter}
                  startIcon={<SearchIcon sx={{ color: "white" }} />}
                  sx={{
                    backgroundColor: "#5b5b5f",
                    textTransform: "none",
                    color: "white",
                    "&:hover": { backgroundColor: alpha("rgb(244, 177, 14)", 0.8) },
                    "& .MuiButton-startIcon svg": {
                      color: "white",
                    },
                  }}
                >
                  Aplicar Filtros
                </Button>
                {Object.values(atributosEntidadFiltro).filter(v => v).length > 0 && (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setAtributosEntidadFiltro({})
                      handleFilter()
                    }}
                    sx={{ 
                      textTransform: "none",
                      color: "#5b5b5f",
                      borderColor: "#5b5b5f",
                      "&:hover": {
                        borderColor: "rgb(244, 177, 14)",
                        backgroundColor: alpha("rgb(244, 177, 14)", 0.1),
                      },
                    }}
                  >
                    Limpiar Atributos
                  </Button>
                )}
              </Box>
            </Paper>
          )}

          {/* Subbox de Medios de Pago */}
          {mostrarFiltroMediosPago && (
            <Paper
              elevation={2}
              sx={{
                p: 2,
                backgroundColor: alpha(theme.palette.background.default, 0.5),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 600, color: "#5b5b5f" }}>
                  <PaymentIcon fontSize="small" sx={{ color: "rgb(244, 177, 14)" }} />
                  Medios de Pago
                </Typography>
                <IconButton size="small" onClick={() => setMostrarFiltroMediosPago(false)} sx={{ color: "#5b5b5f" }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2, alignItems: "center" }}>
                <Autocomplete
                  size="small"
                  disablePortal
                  options={tipoMedioDePago}
                  getOptionLabel={(option) => option.descripcion || ""}
                  value={selectedTipoMedioDePago}
                  onChange={(event, newValue) => {
                    setSelectedTipoMedioDePago(newValue);
                    if (!newValue) {
                      setSelectedMedioDePago(null);
                    }
                  }}
                  sx={{ flex: 1, minWidth: 200 }}
                  renderInput={(params) => <TextField {...params} label="Tipo de Medio de Pago" variant="outlined" size="small" />}
                />
                
                <Autocomplete
                  size="small"
                  disablePortal
                  options={medioDePagoIdTipoEspecifico}
                  getOptionLabel={(option) => option.descripcion || ""}
                  value={selectedMedioDePago}
                  onChange={(event, newValue) => {
                    setSelectedMedioDePago(newValue);
                  }}
                  disabled={!selectedTipoMedioDePago}
                  sx={{ flex: 1, minWidth: 200 }}
                  renderInput={(params) => <TextField {...params} label="Medio de Pago Específico" variant="outlined" size="small" />}
                />
              </Box>
              <Box sx={{ display: "flex", gap: 1, justifyContent: "flex-end", mt: 2 }}>
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleFilter}
                  startIcon={<SearchIcon sx={{ color: "white" }} />}
                  sx={{
                    backgroundColor: "#5b5b5f",
                    textTransform: "none",
                    color: "white",
                    "&:hover": { backgroundColor: alpha("rgb(244, 177, 14)", 0.8) },
                    "& .MuiButton-startIcon svg": {
                      color: "white",
                    },
                  }}
                >
                  Aplicar
                </Button>
                {(selectedTipoMedioDePago || selectedMedioDePago) && (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setSelectedTipoMedioDePago(null)
                      setSelectedMedioDePago(null)
                      handleFilter()
                    }}
                    sx={{ 
                      textTransform: "none",
                      color: "#5b5b5f",
                      borderColor: "#5b5b5f",
                      "&:hover": {
                        borderColor: "rgb(244, 177, 14)",
                        backgroundColor: alpha("rgb(244, 177, 14)", 0.1),
                      },
                    }}
                  >
                    Limpiar
                  </Button>
                )}
              </Box>
            </Paper>
          )}

          {/* Subbox de Tipo de Transacción */}
          {mostrarFiltroTipoTransaccion && (
            <Paper
              elevation={2}
              sx={{
                p: 2,
                backgroundColor: alpha(theme.palette.background.default, 0.5),
                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
              }}
            >
              <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
                <Typography variant="subtitle2" sx={{ display: "flex", alignItems: "center", gap: 1, fontWeight: 600, color: "#5b5b5f" }}>
                  <CategoryIcon fontSize="small" sx={{ color: "rgb(244, 177, 14)" }} />
                  Tipo de Transacción
                </Typography>
                <IconButton size="small" onClick={() => setMostrarFiltroTipoTransaccion(false)} sx={{ color: "#5b5b5f" }}>
                  <CloseIcon fontSize="small" />
                </IconButton>
              </Box>
              <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
                <Autocomplete
                  size="small"
                  disablePortal
                  options={Array.isArray(tipoTransaccion) ? tipoTransaccion : []}
                  getOptionLabel={(option) => option?.descripcion || ""}
                  value={selectedTipoTransaccion}
                  onChange={(event, newValue) => {
                    setSelectedTipoTransaccion(newValue);
                  }}
                  sx={{ flex: 1 }}
                  renderInput={(params) => (
                    <TextField 
                      {...params} 
                      label="Tipo de Transacción" 
                      variant="outlined" 
                      size="small"
                      placeholder={(!tipoTransaccion || tipoTransaccion.length === 0) ? "Cargando tipos..." : "Seleccionar tipo"}
                    />
                  )}
                />
                <Button
                  variant="contained"
                  size="small"
                  onClick={handleFilter}
                  startIcon={<SearchIcon sx={{ color: "white" }} />}
                  sx={{
                    backgroundColor: "#5b5b5f",
                    textTransform: "none",
                    color: "white",
                    "&:hover": { backgroundColor: alpha("rgb(244, 177, 14)", 0.8) },
                    "& .MuiButton-startIcon svg": {
                      color: "white",
                    },
                  }}
                >
                  Aplicar
                </Button>
                {selectedTipoTransaccion && (
                  <Button
                    size="small"
                    variant="outlined"
                    onClick={() => {
                      setSelectedTipoTransaccion(null)
                      handleFilter()
                    }}
                    sx={{ 
                      textTransform: "none",
                      color: "#5b5b5f",
                      borderColor: "#5b5b5f",
                      "&:hover": {
                        borderColor: "rgb(244, 177, 14)",
                        backgroundColor: alpha("rgb(244, 177, 14)", 0.1),
                      },
                    }}
                  >
                    Limpiar
                  </Button>
                )}
              </Box>
            </Paper>
          )}
        </Box>
      )}
    </>
  );

  return (
    <div
      className="tablaVentasContainer"
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh", // Toda la ventana
        overflowX: "auto", // Sin scroll en el contenedor principal
      }}
    >
      <ThemeProvider theme={theme}>
        {/* Contenedor de filtros para Desktop (siempre visible) */}
        {!isLaptopDown && (
          <Collapse in={true} timeout={250}>
            <Paper
              className="diseñoFiltroTransaccionesVenta"
              elevation={3}
              sx={{
                p: 2,
                mb: 2,
                borderRadius: 2,
                backgroundColor: alpha(theme.palette.background.paper, 0.9),
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                maxHeight: "40vh",
                overflow: "auto",
                flexShrink: 0,
                "&::-webkit-scrollbar": {
                  width: "8px",
                  height: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: alpha(theme.palette.primary.main, 0.4),
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: alpha(theme.palette.primary.main, 0.6),
                  },
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: alpha(theme.palette.grey[300], 0.3),
                  borderRadius: "4px",
                },
              }}
            >
              {renderFiltrosContent()}
            </Paper>
          </Collapse>
        )}

        {/* Menú lateral (solo desktop) */}
        {!isLaptopDown && (
          <Drawer
            anchor="right"
            open={sidebarOpen}
            onClose={toggleSidebar}
            variant="persistent"
            sx={{
              "& .MuiDrawer-paper": {
                width: 80,
                top: 0,
                height: "100vh",
                backgroundColor: alpha(theme.palette.background.paper, 0.98),
                borderLeft: `2px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                boxShadow: "-4px 0 20px rgba(0,0,0,0.1)",
                zIndex: 1200,
                overflowX: "hidden",
              },
            }}
          >
            <Box sx={{ display: "flex", flexDirection: "column", height: "100%", p: 1 }}>
              {/* Botón de cerrar */}
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  mb: 2,
                  pb: 1,
                  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                }}
              >
                <IconButton size="small" onClick={toggleSidebar}>
                  <ChevronRightIcon fontSize="small" />
                </IconButton>
              </Box>

              <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                {/* 1. Atributos de Entidad */}
                <Tooltip title="Filtros por Atributos de Entidad" placement="left">
                  <IconButton
                    onClick={() => toggleFiltro('cliente')}
                    sx={{
                      color: mostrarFiltroCliente || Object.values(atributosEntidadFiltro).filter(v => v).length > 0 ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarFiltroCliente || Object.values(atributosEntidadFiltro).filter(v => v).length > 0 ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                      bgcolor: mostrarFiltroCliente ? alpha("rgb(244, 177, 14)", 0.1) : "transparent",
                      "&:hover": {
                        bgcolor: alpha("rgb(244, 177, 14)", 0.15),
                      },
                    }}
                  >
                    <Badge 
                      badgeContent={Object.values(atributosEntidadFiltro).filter(v => v).length > 0 ? 1 : 0} 
                      color="secondary"
                    >
                      <PersonIcon fontSize="small" />
                    </Badge>
                  </IconButton>
                </Tooltip>

                {/* 2. Medios de Pago */}
                <Tooltip title="Filtros de Medios de Pago" placement="left">
                  <IconButton
                    onClick={() => toggleFiltro('mediosPago')}
                    sx={{
                      color: mostrarFiltroMediosPago || selectedTipoMedioDePago || selectedMedioDePago ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarFiltroMediosPago || selectedTipoMedioDePago || selectedMedioDePago ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                      bgcolor: mostrarFiltroMediosPago ? alpha("rgb(244, 177, 14)", 0.1) : "transparent",
                      "&:hover": {
                        bgcolor: alpha("rgb(244, 177, 14)", 0.15),
                      },
                    }}
                  >
                    <Badge badgeContent={(selectedTipoMedioDePago || selectedMedioDePago) ? 1 : 0} color="secondary">
                      <PaymentIcon fontSize="small" />
                    </Badge>
                  </IconButton>
                </Tooltip>

                {/* 3. Tipo de Transacción */}
                <Tooltip title="Filtros de Tipo de Transacción" placement="left">
                  <IconButton
                    onClick={() => toggleFiltro('tipoTransaccion')}
                    sx={{
                      color: mostrarFiltroTipoTransaccion || selectedTipoTransaccion ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarFiltroTipoTransaccion || selectedTipoTransaccion ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                      bgcolor: mostrarFiltroTipoTransaccion ? alpha("rgb(244, 177, 14)", 0.1) : "transparent",
                      "&:hover": {
                        bgcolor: alpha("rgb(244, 177, 14)", 0.15),
                      },
                    }}
                  >
                    <Badge badgeContent={selectedTipoTransaccion ? 1 : 0} color="secondary">
                      <CategoryIcon fontSize="small" />
                    </Badge>
                  </IconButton>
                </Tooltip>

                {/* 4. Totales/Matemáticas */}
                <Divider sx={{ my: 1 }} />
                <Tooltip title="Mostrar/Ocultar Totales" placement="left">
                  <IconButton
                    onClick={() => setMostrarTotales(!mostrarTotales)}
                    sx={{
                      color: mostrarTotales ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      "& svg": {
                        color: mostrarTotales ? "rgb(244, 177, 14)" : "rgba(0, 0, 0, 0.54) !important",
                      },
                      bgcolor: mostrarTotales ? alpha("rgb(244, 177, 14)", 0.1) : "transparent",
                      "&:hover": {
                        bgcolor: alpha("rgb(244, 177, 14)", 0.15),
                      },
                    }}
                  >
                    <CalculateIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

                {/* 5. Mostrar Transacciones Eliminadas - Solo si tiene permiso */}
                {tieneAccesoFuncionalidad(user, 'TRANSACCIONES5', 'verTransaccionesEliminadas') && (
                  <Tooltip title={mostrarDeletes ? "Ocultar eliminadas" : "Mostrar eliminadas"} placement="left">
                    <IconButton
                      onClick={() => {
                        const nuevoEstado = !mostrarDeletes;
                        setMostrarDeletes(nuevoEstado);
                        
                        // Refrescar datos con el nuevo estado
                        const medioDePagoId = selectedMedioDePago ? selectedMedioDePago.id : null;
                        const tipoTransaccionId = selectedTipoTransaccion ? selectedTipoTransaccion.id : null;
                        const tipoMedioDePagoId = selectedTipoMedioDePago ? selectedTipoMedioDePago.id : null;
                        const idEntidad = dniCliente ? dniCliente.id : null;
                        const ubicacionId = selectedUbicacion ? selectedUbicacion.id : null;
                        
                        fetchData(
                          startDate,
                          endDate,
                          medioDePagoId,
                          tipoMedioDePagoId,
                          tipoTransaccionId,
                          1, // Resetear a página 1
                          idTransaccionSearch,
                          idEntidad,
                          ubicacionId,
                          100,
                          atributosEntidadFiltro,
                          nuevoEstado // El nuevo estado de mostrarDeletes
                        );
                      }}
                      sx={{
                        color: mostrarDeletes ? "#ef5350" : "rgba(0, 0, 0, 0.54) !important",
                        "& svg": {
                          color: mostrarDeletes ? "#ef5350" : "rgba(0, 0, 0, 0.54) !important",
                        },
                        bgcolor: mostrarDeletes ? alpha("#ef5350", 0.1) : "transparent",
                        "&:hover": {
                          bgcolor: alpha("#ef5350", 0.15),
                        },
                      }}
                    >
                      <DeleteIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            </Box>
          </Drawer>
        )}

        {/* Contenedor de la tabla */}
        {/* Contenedor de la tabla */}
        <Paper
          sx={{
            flex: 1,
            minHeight: 0,
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            m: 1,
            mt: 0,
            borderRadius: 3,
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
            position: "relative",
          }}
        >
          <DataGrid
key={isNavbarCollapsed ? "collapsed" : "expanded"}
            rows={transaccionTransformedReforged}
            columns={columns}
            getRowId={(row) => row.id}
            pageSize={limit}
            paginationMode="server"
            className="tablaVentasDataGrid"
            rowCount={totalCount} // usa el total real de registros
            page={page - 1} // DataGrid cuenta desde 0
            onPageChange={(newPage) => setPage(newPage + 1)}
            onRowSelectionModelChange={(newSelection) => {
              const selectedData = transaccionTransformedReforged.filter(
                (row) => newSelection.includes(row.id)
              );
              setSelectedRows(selectedData);
            }}
            getRowHeight={() => 35}
            headerHeight={35}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "row-color-alt" // Alternar filas con este color
                : "row-color-default"
            }
            sx={{
              height: "100%",
              border: 0,
              "& .MuiDataGrid-footerContainer": {
                display: "none !important", // Si no funciona, usa la regla CSS global con !important
              },
              "& .MuiDataGrid-columnHeaders": {
                backgroundColor: "#5b5b5f",
                color: "white",
                borderBottom: "2px solid #333",
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeader": {
                //MANEJA CSS HEADER
                height: "45px !important",
                minHeight: "45px !important",
                maxHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                //MANEJA CSS HEADER
                color: "white !important",
                lineHeight: "45px !important",
              },
              "& .MuiDataGrid-columnHeaderTitle": {
                color: "white !important",
              },
              "& .MuiDataGrid-columnHeaderTitle .MuiDataGrid-menuIconButton": {
                color: "white !important",
              },
              "& .MuiDataGrid-menuIconButton": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiInputBase-root": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiTablePagination-root": {
                color: "black !important",
              },
              "& .MuiSelect-icon": {
                color: "rgb(244, 177, 14) !important",
              },
              "& .MuiDataGrid-cell": {
                borderBottom: "1px solid #ccc",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              },
              "& .MuiDataGrid-row": {
                "&:nth-of-type(even)": {
                  backgroundColor: "#F7F7F7",
                },
                "&:hover": {
                  backgroundColor: "#E3EAFD",
                  transition: "background 0.3s ease",
                },
              },
              "& .MuiDataGrid-footerContainer": {
                position: "sticky",
                bottom: 0,
                backgroundColor: "#ffffff",
                borderTop: "1px solid #ddd",
                zIndex: 10,
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                width: "8px",
              },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar-thumb": {
                backgroundColor: "#888",
                borderRadius: "10px",
              },
            }}
            components={{
              Pagination: () => null,
            }}
          />
        </Paper>
        {/* Contenedor del footer (paginación) */}
        <Box sx={{ flexShrink: 0, p: 1 }}>
          <CustomPagination
            currentPage={page}
            totalPages={totalPages}
            totalCount={totalCount}
            vieneDe={"tablaTransaccion"}
            onPageChange={(newPage) => setPage(newPage)}
          />
        </Box>
        {/* Footer fijo - Totales (solo si está activado) */}
        {mostrarTotales && (
          <Paper
            sx={{
              width: "100%",
              borderTop: "1px solid #ddd",
              backgroundColor: "#f0f0f0",
            }}
          >
          <TableContainer
            component={Paper}
            sx={{ maxHeight: 300, width: "100%" }}
          >
            <Table sx={{ width: "100%" }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <strong>Referencias</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Venta</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Ingreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Venta + Ingreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong> - </strong>
                  </TableCell>
                  <TableCell>
                    <strong>Compra</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Egreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong>Compra + Egreso</strong>
                  </TableCell>
                  <TableCell>
                    <strong> - </strong>
                  </TableCell>
                  <TableCell>
                    <strong>Total Final</strong>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{ color: "black", fontWeight: "bold" }}
                  >
                    <Tooltip title="Total de todas las páginas" arrow placement="top">
                      <span style={{ cursor: "help" }}>Totales por fecha</span>
                    </Tooltip>
                  </TableCell>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{ color: "#4CAF50", fontWeight: "bold", cursor: "help" }}
                    >
                      ${totalesPorTipoMedioDePago?.Venta.toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{ color: "#4CAF50", fontWeight: "bold", cursor: "help" }}
                    >
                      $
                      {totalesPorTipoMedioDePago?.Ingreso.toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{ color: "#4CAF50", fontWeight: "bold", cursor: "help" }}
                    >
                      $
                      {(
                        totalesPorTipoMedioDePago?.Venta +
                        totalesPorTipoMedioDePago?.Ingreso
                      ).toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{ color: "#FF9800", fontWeight: "bold", cursor: "help" }}
                    >
                      ${totalesPorTipoMedioDePago?.Compra.toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{ color: "#FF9800", fontWeight: "bold", cursor: "help" }}
                    >
                      ${totalesPorTipoMedioDePago?.Egreso.toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{ color: "#FF9800", fontWeight: "bold", cursor: "help" }}
                    >
                      $
                      {(
                        totalesPorTipoMedioDePago?.Compra +
                        totalesPorTipoMedioDePago?.Egreso
                      ).toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <Tooltip title="Total de todas las páginas" arrow placement="top">
                    <TableCell
                      align="center"
                      sx={{
                        color:
                          totalesPorTipoMedioDePago?.Venta +
                            totalesPorTipoMedioDePago?.Ingreso -
                            totalesPorTipoMedioDePago?.Compra -
                            totalesPorTipoMedioDePago?.Egreso >=
                          0
                            ? "#4CAF50"
                            : "#FF9800",
                        fontWeight: "bold",
                        cursor: "help",
                      }}
                    >
                      $
                      {(
                        totalesPorTipoMedioDePago?.Venta +
                        totalesPorTipoMedioDePago?.Ingreso -
                        totalesPorTipoMedioDePago?.Compra -
                        totalesPorTipoMedioDePago?.Egreso
                      ).toLocaleString("es-AR")}
                    </TableCell>
                  </Tooltip>
                </TableRow>
                <TableRow>
                  <TableCell
                    align="center"
                    sx={{ color: "black", fontWeight: "bold" }}
                  >
                    Totales por medio de pago
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Venta.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Ingreso.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#4CAF50", fontWeight: "bold" }}
                  >
                    $
                    {(
                      totalesPorTipo?.Venta + totalesPorTipo?.Ingreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Compra.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    ${totalesPorTipo?.Egreso.toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "#FF9800", fontWeight: "bold" }}
                  >
                    $
                    {(
                      totalesPorTipo?.Compra + totalesPorTipo?.Egreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{ color: "gray", fontWeight: "bold" }}
                  >
                    -
                  </TableCell>
                  <TableCell
                    align="center"
                    sx={{
                      color:
                        totalesPorTipo?.Venta +
                          totalesPorTipo?.Ingreso -
                          totalesPorTipo?.Compra -
                          totalesPorTipo?.Egreso >=
                        0
                          ? "#4CAF50"
                          : "#FF9800",
                      fontWeight: "bold",
                    }}
                  >
                    $
                    {(
                      totalesPorTipo?.Venta +
                      totalesPorTipo?.Ingreso -
                      totalesPorTipo?.Compra -
                      totalesPorTipo?.Egreso
                    ).toLocaleString("es-AR")}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Paper>
        )}
      </ThemeProvider>

      {/* Modal */}

      {openModalVenta === true ? (
        <ModalViewTablaVenta
          openModal={openModalVenta}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalCompra === true ? (
        <ModalViewTablaCompra
          openModal={openModalCompra}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
          compraItems={compraItems}
        />
      ) : null}
      {openModalPresupuesto === true ? (
        <ModalViewTablaPresupuesto
          openModal={openModalPresupuesto}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalIngreso === true ? (
        <ModalViewTablaIngreso
          openModal={openModalIngreso}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalEgreso === true ? (
        <ModalViewTablaEgreso
          openModal={openModalEgreso}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalDevolucion === true ? (
        <ModalViewTablaDevolucion
          openModal={openModalDevolucion}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
          selectedTransaccionEntidad={selectedTransaccionEntidad}
          transaccionItems={transaccionItems}
        />
      ) : null}
      {openModalGenerico === true ? (
        <ModalViewTablaGenerico
          openModal={openModalGenerico}
          handleCloseModal={handleCloseModal}
          selectedTransaccion={selectedTransaccion}
        />
      ) : null}

      {/* Modal de eliminación con comentario obligatorio */}
      <Dialog 
        open={openDeleteModal} 
        onClose={handleCancelDelete}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          }
        }}
      >
        <DialogTitle sx={{ 
          borderBottom: '1px solid rgba(0,0,0,0.08)',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          pb: 2,
        }}>
          <WarningAmberIcon sx={{ color: '#ff9800', fontSize: 28 }} />
          <Box>
            <Typography variant="h6" component="span" sx={{ fontWeight: 600 }}>
              Confirmar Eliminación
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Transacción ID: {transaccionToDelete?.id}
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent sx={{ pt: 3 }}>
          <Stack spacing={2}>
            <Alert severity="warning" sx={{ borderRadius: 2 }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                Esta acción eliminará la transacción permanentemente
              </Typography>
              <Typography variant="caption" color="text.secondary">
                Debes proporcionar un motivo para mantener la trazabilidad
              </Typography>
            </Alert>

            <Box>
              <TextField
                label="Motivo de eliminación"
                fullWidth
                required
                multiline
                rows={4}
                placeholder="Describe el motivo por el cual se elimina esta transacción... *"
                value={deleteComentario}
                onChange={(e) => setDeleteComentario(e.target.value)}
                autoFocus
                error={deleteComentario.trim() === '' && deleteComentario !== ''}
                helperText={
                  deleteComentario.trim() === '' && deleteComentario !== ''
                    ? 'El motivo de eliminación es obligatorio'
                    : ''
                }
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: 2,
                  }
                }}
              />

              <Box
                sx={{
                  mt: 1,
                  display: 'flex',
                  alignItems: 'center',
                  gap: 0.5,
                }}
              >
                <InfoIcon sx={{ fontSize: 14, color: 'text.secondary' }} />
                <Typography variant="caption" color="text.secondary">
                  Este comentario quedará registrado en el historial de auditoría
                </Typography>
              </Box>
            </Box>
          </Stack>
        </DialogContent>

        <DialogActions sx={{ 
          px: 3, 
          pb: 2.5, 
          pt: 2,
          borderTop: '1px solid rgba(0,0,0,0.08)',
          gap: 1 
        }}>
          <Button
            onClick={handleCancelDelete}
            variant="outlined"
            startIcon={<CloseIcon />}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              borderColor: 'rgba(0,0,0,0.23)',
              color: 'text.primary',
              '&:hover': {
                borderColor: 'rgba(0,0,0,0.4)',
                bgcolor: 'rgba(0,0,0,0.04)',
              }
            }}
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            startIcon={<DeleteIcon />}
            disabled={!deleteComentario.trim()}
            sx={{
              borderRadius: 2,
              textTransform: 'none',
              fontWeight: 500,
              bgcolor: '#d32f2f',
              '&:hover': {
                bgcolor: '#b71c1c',
              },
              '&:disabled': {
                bgcolor: 'rgba(0,0,0,0.12)',
              }
            }}
          >
            Eliminar Transacción
          </Button>
        </DialogActions>
      </Dialog>

      {/* Backdrop de Loading durante eliminación */}
      <Backdrop
        sx={{ 
          color: '#fff', 
          zIndex: (theme) => theme.zIndex.drawer + 1,
          flexDirection: 'column',
          gap: 2,
        }}
        open={loading}
      >
        <CircularProgress color="inherit" />
        <Typography variant="h6" component="div">
          {loadingMessage}
        </Typography>
      </Backdrop>
    </div>
  );
}
